const request = require('request');
const config = require('./config');

var get = (token) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/funcionalidade',
      method: 'GET',
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body:body});
    });
  });
};

var getByPermissionID = (token,filters) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/funcionalidade/getFuncionalidadesByPermissionID',
      method: 'GET',
      qs: filters
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body:body});
    });
  });
};

module.exports = {
  get:get,
  getByPermissionID:getByPermissionID
}